/**
 * Contenido fijo del banner de campaña (HU-016) — todo lo que NO es
 * banner/logo/slogan, que sí vienen de `Configuracion` (editables desde
 * Configuración → Identidad). Decisión explícita del cliente: este texto
 * queda fijo en código para esta campaña puntual, no se agrega como campo
 * editable al modelo — si cambia la campaña, se edita este archivo.
 *
 * No hay un flag `enabled` acá: la campaña está activa si y solo si
 * `configuracion.banner` existe (`useConfiguracion`, ya público) — sin
 * banner cargado, ningún componente de `components/campaign/` renderiza
 * nada y la app queda igual que si esta carpeta no existiera.
 */
export const campaign = {
  party: 'Avanza País',
  candidate: 'Enrique Ocrospoma · Jesús María',
  headline: 'Un distrito con más oportunidades',
  tagline: 'Más cerca, más acción',
  pillars: ['Seguridad', 'Orden', 'Experiencia'],
  ctaLabel: 'Ver propuestas',
  // Sin URL real todavía — completar antes de que el CTA quede visible en
  // producción (mientras tanto los componentes lo tratan como deshabilitado).
  ctaUrl: '',
  autoCollapseMs: 8000,
  showOncePer: 'session', // 'session' | 'day' | 'always'
};
